/**
 * 应用商店下载入口网格。
 *
 * 没有各商店的官方 Logo 素材，用「首字 + 品牌色」的小方块代替，
 * 视觉上够区分，也不用额外请求一堆图片。
 */

/** 品牌色，仅用于小方块的底色。取不到的走默认强调色。 */
const STORE_TINTS = {
  ios: '#1c1c1e',
  huawei: '#c8102e',
  honor: '#0a5bd3',
  xiaomi: '#ff6900',
  oppo: '#1d9e4b',
  vivo: '#0a5bd3',
  samsung: '#1428a0',
  meizu: '#00a0e9',
  tencent: '#12b7f5',
  google: '#4285f4',
};

/** 每行最多两个，取名字里第一个非空字符作为标记。 */
function markOf(store) {
  return store.name.replace(/\s/g, '').charAt(0) || '?';
}

export default function StoreGrid({ items, preferredId, onSelect }) {
  return (
    <div className="store-grid">
      {items.map((store) => {
        const preferred = store.id === preferredId;

        return (
          <button
            key={store.id}
            type="button"
            className={`store-item${preferred ? ' store-item--preferred' : ''}`}
            style={{ '--store-tint': STORE_TINTS[store.id] ?? 'var(--accent-strong)' }}
            onClick={() => onSelect(store)}
          >
            <span className="store-item__mark" aria-hidden="true">
              {markOf(store)}
            </span>

            <span className="store-item__body">
              <span className="store-item__name">{store.name}</span>
              <span className="store-item__vendor">{store.vendor}</span>
            </span>

            {preferred ? <span className="store-item__badge">推荐</span> : null}
          </button>
        );
      })}
    </div>
  );
}
